<script>
import { ref, onMounted, toRefs, watch, computed, reactive } from "vue";
import { useScrollEffect } from "../functions";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop", "nowFeature", "isOpen"],
	emits: ["changeContentStatus", "changeShowIndex"],
	setup(props, { emit }) {
		const { windowWidth, windowHeight, scrollTop, nowFeature } = toRefs(
			props
		);

		const container = ref(null);
		const imgA = ref(null);
		const imgB = ref(null);
		const mainTitle = ref(null);
		const cover = ref(null);
		const featuresA = ref(null);
		const featuresB = ref(null);
		const featureA1 = ref(null);
		const featureA2 = ref(null);
		const featureB1 = ref(null);
		const featureB2 = ref(null);
		const lineA1 = ref(null);
		const lineA2 = ref(null);
		const lineB1 = ref(null);
		const lineB2 = ref(null);

		const containerHeight = ref(0);
		const imgSrcA = reactive({
			pc: require("../assets/launchImg/background_c3-1.jpg"),
			mobile: require("../assets/launchImg/background_c3-1_mobile.jpg"),
		});
		const imgSrcB = reactive({
			pc: require("../assets/launchImg/background_c3-2.jpg"),
			mobile: require("../assets/launchImg/background_c3-2_mobile.jpg"),
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});

		const containerCoeff = useScrollEffect(
			-100,
			1 * windowHeight.value,
			100,
			0
		);
		const fadeInCoeff = useScrollEffect(
			0.8 * windowHeight.value,
			1.4 * windowHeight.value,
			-0.5,
			1.1
		);
		const fadeOutCoeff = useScrollEffect(
			2 * windowHeight.value,
			2.6 * windowHeight.value,
			-1.1,
			1.1
		);
		const textCoeff = computed(() => {
			return useScrollEffect(
				2.3 * windowHeight.value,
				2.6 * windowHeight.value,
				-0.5,
				1.1
			);
		});
		const imgCoeff = computed(() => {
			return useScrollEffect(
				3.0 * windowHeight.value,
				3.6 * windowHeight.value,
				-1.1,
				1.1
			);
		});
		const imgXOffset = computed(() => {
			return useScrollEffect(
				3.9 * windowHeight.value,
				5 * windowHeight.value,
				0,
				windowWidth.value > 992 ? -60 : -95
			);
		});
		const zoomCoeff = computed(() => {
			return useScrollEffect(
				1 * windowHeight.value,
				3.3 * windowHeight.value,
				1,
				1.05
			);
		});

		const isShow = computed({
			get: () => {
				return props.isOpen;
			},
			set: (val) => {
				emit("changeContentStatus", val);
			},
		});
		const showContent = (val) => {
			isShow.value = !isShow.value;
			emit("changeShowIndex", val);
		};

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			if (
				windowWidth.value / windowHeight.value < 1920 / 1080 &&
				windowWidth.value > 992
			) {
				imgB.value.style.backgroundSize = "auto 100%";
			}
			if (windowWidth.value <= 420) {
				featureB1.value.style.left = `${0.185 * windowWidth.value +
					205.8 +
					0.344 * windowHeight.value -
					333}px`;
			}
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
				if (
					windowWidth.value / windowHeight.value < 1920 / 1080 &&
					windowWidth.value > 992
				) {
					imgB.value.style.backgroundSize = "auto 100%";
				}
				if (windowWidth.value <= 420) {
					featureB1.value.style.left = `${0.185 * windowWidth.value +
						205.8 +
						0.344 * windowHeight.value -
						333}px`;
				} else {
					featureB1.value.style.removeProperty("left");
				}
			});
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (
					innerHeight.value > -100 &&
					innerHeight.value < 1 * windowHeight.value
				) {
					container.value.style.backgroundPosition = `center calc(50%${
						windowWidth.value <= 650 ? " - 12vw" : ""
					} + ${nv * containerCoeff.a + containerCoeff.b}px)`;
				} else if (
					innerHeight.value > windowHeight.value &&
					innerHeight.value < 3.9 * windowHeight.value
				) {
					imgA.value.style.transform = `translateY(-50%) scale(${nv *
						zoomCoeff.value.a +
						zoomCoeff.value.b})`;
				}

				if (innerHeight.value > 0.8 * windowHeight.value) {
					mainTitle.value.style.opacity = `${nv * fadeInCoeff.a +
						fadeInCoeff.b}`;
					cover.value.style.opacity = `${nv * fadeInCoeff.a +
						fadeInCoeff.b}`;
				} else if (innerHeight.value <= 0.8 * windowHeight.value) {
					mainTitle.value.style.opacity = 0;
					cover.value.style.opacity = 0;
				}

				if (innerHeight.value > 2 * windowHeight.value) {
					mainTitle.value.style.opacity = `${-nv * fadeOutCoeff.a -
						fadeOutCoeff.b}`;
					cover.value.style.opacity = `${-nv * fadeOutCoeff.a -
						fadeOutCoeff.b}`;
				}

				if (
					innerHeight.value >= 2.3 * windowHeight.value &&
					innerHeight.value <= 3.3 * windowHeight.value
				) {
					if (!featureA1.value.classList.contains("rush-in")) {
						// featureA1.value.style.transform = `translate(${
						// 	windowWidth.value > 992 ? "-15vw, 0" : "0, -150px"
						// })`;
						featureA1.value.classList.add("rush-in");
						featureA1.value.classList.remove("rush-out");
					}
					if (!featureA2.value.classList.contains("rush-in")) {
						// featureA2.value.style.transform = `translate(${
						// 	windowWidth.value > 992 ? "-15vw, 0" : "0, 150px"
						// })`;
						featureA2.value.classList.add("rush-in");
						featureA2.value.classList.remove("rush-out");
					}
				} else {
					if (featureA1.value.classList.contains("rush-in")) {
						// featureA1.value.style.transform = `translate(0px, 0px)`;
						featureA1.value.classList.remove("rush-in");
						featureA1.value.classList.add("rush-out");
					}
					if (featureA2.value.classList.contains("rush-in")) {
						// featureA2.value.style.transform = `translate(0px, 0px)`;
						featureA2.value.classList.remove("rush-in");
						featureA2.value.classList.add("rush-out");
					}
				}

				if (
					innerHeight.value > 3 * windowHeight.value &&
					innerHeight.value < 3.6 * windowHeight.value
				) {
					imgB.value.style.opacity = `${nv * imgCoeff.value.a +
						imgCoeff.value.b}`;
				} else if (innerHeight.value <= 3 * windowHeight.value) {
					imgB.value.style.opacity = 0;
				} else {
					imgB.value.style.opacity = 1;
					if (
						innerHeight.value > 3.9 * windowHeight.value &&
						innerHeight.value <= 5 * windowHeight.value
					) {
						imgA.value.style.transform =
							"translateY(-50%) scale(1)";
						imgB.value.style.backgroundPosition = `${-nv *
							imgXOffset.value.a -
							imgXOffset.value.b}% center`;
						featuresB.value.style.transform = `translateX(${0.3 *
							(nv * imgXOffset.value.a + imgXOffset.value.b)}%)`;
					}
				}

				if (innerHeight.value >= 3.6 * windowHeight.value) {
					featuresB.value.style.zIndex = 92;
					if (!featureB1.value.classList.contains("rush-in")) {
						// featureB1.value.style.transform = `translate(${
						// 	windowWidth.value > 992 ? "-15vw, 0" : "0, -150px"
						// })`;
						featureB1.value.classList.add("rush-in");
						featureB1.value.classList.remove("rush-out");
					}
					if (!featureB2.value.classList.contains("rush-in")) {
						// featureB2.value.style.transform = `translate(${
						// 	windowWidth.value > 992 ? "-15vw, 0" : "0, 150px"
						// })`;
						featureB2.value.classList.add("rush-in");
						featureB2.value.classList.remove("rush-out");
					}
				} else {
					featuresB.value.style.zIndex = 88;
					if (featureB1.value.classList.contains("rush-in")) {
						// featureB1.value.style.transform = `translate(0px, 0px)`;
						featureB1.value.classList.remove("rush-in");
						featureB1.value.classList.add("rush-out");
					}
					if (featureB2.value.classList.contains("rush-in")) {
						// featureB2.value.style.transform = `translate(0px, 0px)`;
						featureB2.value.classList.remove("rush-in");
						featureB2.value.classList.add("rush-out");
					}
				}
			}
		);

		return {
			container,
			windowWidth,
			imgSrcA,
			imgSrcB,
			imgA,
			imgB,
			cover,
			mainTitle,
			textCoeff,
			featuresA,
			featuresB,
			featureA1,
			featureA2,
			featureB1,
			featureB2,
			lineA1,
			lineA2,
			lineB1,
			lineB2,
			showContent,
		};
	},
};
</script>

<template>
	<section id="exterior">
		<div class="bg_c3 sticky-wrapper" ref="container">
			<img
				:src="windowWidth > 992 ? imgSrcA.pc : imgSrcA.mobile"
				alt="G26全新BMW 4系列Gran Coupé豪華四門跑車外觀 Air Breather 車側導流氣孔 霧黑運動化側裙"
				ref="imgA"
			/>
			<img
				class="imgB"
				:src="windowWidth > 992 ? imgSrcB.pc : imgSrcB.mobile"
				alt="G26全新BMW 4系列Gran Coupé豪華四門跑車外觀 平整化車門把手 掀背式電動尾門"
			/>
			<div
				class="f2_img"
				:style="{
					backgroundImage: `url(${
						windowWidth > 992 ? imgSrcB.pc : imgSrcB.mobile
					})`,
				}"
				ref="imgB"
			/>
			<div class="contain-img"></div>
			<div class="main-cover" ref="mainTitle">
				<h2 class="title_main text_ch_medium shine">
					<span class="inner_title_main">鋒芒美學 獨具一</span>
					<span>格</span>
				</h2>
				<p class="title_sub text_ch_medium">
					<span>難以模仿的前衛設計語彙，</span><br />
					<span>
						創造出過目難忘的優雅流線，
						<br class="mobile_break" />
						以獨到的鋒芒美學，掠奪世人目光。
					</span>
				</p>
			</div>
			<div class="cover" ref="cover"></div>
		</div>
	</section>
	<section id="exterior-text">
		<div class="sticky-wrapper">
			<div class="features_A" ref="featuresA">
				<div
					class="feature feature_A-1 text_ch_heavy"
					@click="showContent(0)"
					ref="featureA1"
				>
					<p
						><span class="text_en_bold">Air Breather </span
						>車側導流氣孔</p
					>
					<span class="arrow_goto"></span>
				</div>
				<!-- <span class="indicated-line line_A-1" ref="lineA1"></span> -->
				<div
					class="feature feature_A-2 text_ch_heavy"
					@click="showContent(1)"
					ref="featureA2"
				>
					<p>霧黑運動化側裙</p>
					<span class="arrow_goto"></span>
				</div>
				<!-- <span class="indicated-line line_A-2" ref="lineA2"></span> -->
			</div>
			<div class="features_B" ref="featuresB">
				<div
					class="feature feature_B-1 text_ch_heavy"
					@click="showContent(2)"
					ref="featureB1"
				>
					<p>平整化車門把手</p>
					<span class="arrow_goto"></span>
				</div>
				<!-- <span class="indicated-line line_B-1" ref="lineB1"></span> -->
				<div
					class="feature feature_B-2 text_ch_heavy"
					@click="showContent(3)"
					ref="featureB2"
				>
					<p>掀背式電動尾門</p>
					<span class="arrow_goto"></span>
				</div>
				<!-- <span class="indicated-line line_B-2" ref="lineB2"></span> -->
			</div>
		</div>
	</section>
</template>

<style lang="sass" scoped>
$timing: cubic-bezier(0.83, 0, 0.17, 1)
// $timing: cubic-bezier(0.22, 1, 0.36, 1)
// $timing: cubic-bezier(0.64, 0, 0.78, 0)
$offset: 75px

#exterior
    z-index: 57
    // z-index: 67
    background-color: #111
    .bg_c3
        width: 100%
        // background-size: cover
        // background-repeat: no-repeat
        // background-position: center calc(50% + 100px)
        // background-position: center calc(50% + 100px + 100.02vw - 509.2px)
        img
            position: absolute
            width: 100%
            height: 100%
            top: 50%
            transform: translateY(-50%)
            object-fit: cover
        .imgB
            display: none
        .f2_img
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            background-size: 130% auto
            background-repeat: no-repeat
            background-position: 0 center
            opacity: 0
            &::before
                content: ""
                position: absolute
                display: none
                width: 100%
                height: 58.3%
                left: 0px
                bottom: 0
                background-image: linear-gradient(to bottom, transparent 2%, rgba(#000, 0.9) 98%)
                background-repeat: no-repeat
        .contain-img
            display: none
            position: absolute
            width: 100%
            height: 20%
            bottom: 0px
            background-image: linear-gradient(to bottom, transparent 2%, #000 98%)
            background-position: center
            background-repeat: no-repeat
            z-index: 90
        .cover
            position: absolute
            width: 100%
            height: calc(100% + 60px)
            left: 0
            bottom: -5px
            opacity: 0
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 1))
        .main-cover
            position: relative
            width: 90%
            margin: 0 auto
            top: 70%
            z-index: 90
            text-align: center
            overflow: hidden
            h2
                position: relative
                width: 100vw
                left: 50%
                transform: translateX(-50%)
                text-align: center
                font-size: 3rem
                line-height: 2.83
                color: #999
                span
                    letter-spacing: normal
                    font-size: inherit
                    &.inner_title_main
                        letter-spacing: 15px
                &.shine
                        animation: shine 4s infinite linear forwards
            .title_sub
                position: relative
                margin-top: 10px
                font-size: 1.7rem
                line-height: 2.12
                letter-spacing: 3.06px
                text-align: center
                z-index: 70
                span
                    font-size: inherit
                .mobile_break
                    display: none

#exterior-text
    width: calc(100% - 50px)
    z-index: 67
    .sticky-wrapper
        width: 100%
        .features_B
            z-index: 88
        .features_A, .features_B
            position: absolute
            width: 100%
            height: 100%
            z-index: 90
            top: 0
            // .indicated-line
            //     position: absolute
            //     display: block
            //     width: 150px
            //     height: 1px
            //     left: -160px
            //     top: 50%
            //     transform: translateY(-50%)
            //     background-image: linear-gradient(to right, transparent 2%, #fff 98%)
            //     background-size: cover
            //     background-repeat: no-repeat
            //     &.line_A-1
            //         left: calc(54.5vw + 184.4px)
            //         top: 60.5%
            //     &.line_A-2
            //         left: calc(56.9vw + 236px)
            //         top: 76%
            //     &.line_B-1
            //         left: 68%
            //         top: 50%
            //     &.line_B-2
            //         left: 35%
            //         top: 55%
            .feature
                position: absolute
                cursor: pointer
                user-select: none
                transform: translateX(-15vw)
                opacity: 0
                transition: opacity 0.5s $timing, transform 0.5s $timing
                &.rush-in
                    opacity: 1
                    transform: translateX(0px)
                    // animation: rushIn 0.5s $timing 1 forwards
                &.rush-out
                    opacity: 0
                    transform: translateX(-15vw)
                    transition: opacity 0.3s $timing, transform 0.3s $timing
                    // animation: rushOut 0.3s ease 1 forwards
                &::before
                    content: ""
                    position: absolute
                    display: block
                    width: 150px
                    height: 1px
                    left: -160px
                    top: 50%
                    transform: translateY(-50%)
                    background-image: linear-gradient(to right, transparent 2%, #fff 98%)
                    background-size: cover
                    background-repeat: no-repeat
                &::after
                    content: ""
                    position: absolute
                    display: block
                    width: 100%
                    height: 3px
                    left: 0px
                    bottom: 0
                    transform: translateY(-50%)
                    background-image: url("~@/assets/color-bar.png")
                    background-repeat: repeat-x
                    background-position: 0 0
                    animation: color-bar-loop 2.5s linear infinite forwards
                    background-size: 400px 6px
                p
                    display: inline-block
                    font-size: 1.8rem
                    line-height: 2.4
                    letter-spacing: 1.35px
                    vertical-align: middle
                    span
                        font-size: 1.5rem
                .arrow_goto
                    display: inline-block
                    vertical-align: middle
                    width: 14px
                    height: 32px
                    margin-left: 8px
                    background-image: url("~@/assets/launchImg/plus.png")
                    background-size: 30px 32px
                    background-position: center 4px
                    background-repeat: no-repeat
                    animation: nav_anim 2.5s ease infinite forwards
                &.feature_A-1
                    left: calc(54.5vw + 253.4px)
                    top: calc(60.5% + 10px)
                    &::before
                        width: 5vw
                        left: calc(-5vw - 10px)
                &.feature_A-2
                    left: calc(56.9vw + 271px)
                    top: calc(76% + 40px)
                    transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                    &::before
                        width: 10vw
                        left: calc(-10vw - 10px)
                    &.rush-in
                        // animation-delay: 0.25s
                    &.rush-out
                        // animation-delay: 0.15s
                        transition: opacity 0.3s 0.15s $timing, transform 0.3s 0.15s $timing
                &.feature_B-1
                    left: 68%
                    top: 50%
                    transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                    &.rush-out
                        transition: opacity 0.3s 0.15s $timing, transform 0.3s 0.15s $timing
                &.feature_B-2
                    left: 35%
                    top: 55%

                    &::before
                        width: 290px
                        left: -300px
                    &.rush-in
                        // animation-delay: 0.25s
                    &.rush-out
                        // animation-delay: 0.15s

@media screen and (min-width: 1515px)
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    &.feature_A-1
                        // transform: translateX(2.8vw)
                        &::before
                            width: 7.8vw
                            left: calc(-7.8vw - 10px)
                    &.feature_A-2

@media screen and (max-width: 1440px)
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    .arrow_goto
                        background-position: center 3px

@media screen and (max-width: 992px)
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    // transition: opacity 0.5s $timing, transform 0.5s $timing
                    &.feature_A-1
                        // left: 50%
                        // top: 40%
                        left: calc(61.4vw - 109.1px)
                        top: calc(17.4vw + 157.4px + 73.4% - 623.7px)
                        transform: translate(0px, $offset)
                        &.rush-in
                            transform: translate(0px, 0px)
                            // animation: rushUpIn 0.5s $timing 1 forwards
                        &.rush-out
                            transform: translate(0px, $offset)
                            // animation: rushUpOut 0.3s $timing 1 forwards
                        &::before
                            width: 1px
                            height: 270px
                            background-image: linear-gradient(to top, transparent 2%, #fff 98%)
                            left: 50%
                            top: calc(100% + 10px)
                            transform: translateX(-50%)
                    &.feature_A-2
                        // left: 53.5%
                        // top: 90%\
                        // left: calc(60vw - 60.4px)
                        left: calc(79.8vw - 84.9px)
                        // top: calc(24.9vw + 518.5px + 73.4% - 623.7px)
                        top: calc(24.9vw + 530.5px + 73.4% - 623.7px)
                        transform: translate(0px, $offset * -1)
                        &.rush-in
                            transform: translate(0px, 0px)
                            // animation: rushDownIn 0.5s $timing 1 forwards
                        &.rush-out
                            transform: translate(0px, $offset * -1)
                            // animation: rushDownOut 0.3s $timing 1 forwards
                        &::before
                            width: 1px
                            height: 90px
                            background-image: linear-gradient(to bottom, transparent 2%, #fff 98%)
                            left: 50%
                            top: -90px
                            transform: translateX(-50%)
                    &.feature_B-1
                        // left: 68%
                        left: calc(64.6vw - 75.1px)
                        top: calc(76% + 73.4% - 510.7px)
                        transform: translate(0px, $offset * -1)
                        &.rush-in
                            transform: translate(0px, 0px)
                            // animation: rushUpIn 0.5s $timing 1 forwards
                        &.rush-out
                            transform: translate(0px, $offset * -1)
                            // animation: rushUpOut 0.3s $timing 1 forwards
                        &::before
                            width: 1px
                            height: 190px
                            background-image: linear-gradient(to bottom, transparent 2%, #fff 98%)
                            left: 50%
                            top: -190px
                            transform: translateX(-50%)
                    &.feature_B-2
                        // left: 17%
                        left: calc(27.6vw - 75.4px)
                        top: calc(32% + 73.4% - 549.7px)
                        transform: translate(0px, $offset)
                        &.rush-in
                            transform: translate(0px, 0px)
                            // animation: rushDownIn 0.5s $timing 1 forwards
                        &.rush-out
                            transform: translate(0px, $offset)
                            // animation: rushDownOut 0.3s $timing 1 forwards
                        &::before
                            width: 1px
                            height: 110px
                            background-image: linear-gradient(to top, transparent 2%, #fff 98%)
                            left: 50%
                            top: calc(100% + 10px)
                            transform: translateX(-50%)
@media screen and (max-width: 768px)
    #exterior
        .bg_c3
            .f2_img
                &::before
                    display: block
            .main-cover
                .title_main
                    line-height: 2.22
                    span
                        font-size: 1.8rem
                        &.inner_title_main
                            letter-spacing: 10.8px
                .title_sub
                    font-size: 1.2rem
                    line-height: 2.08
                    letter-spacing: 1.44px
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    &::after
                        height: 2px
                    p
                        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.16)
                        font-size: 1.4rem
                        line-height: 2.57
                        letter-spacing: 0.7px
                        font-family: arudjingxiheipe1xg30_md, 微軟正黑體
                        span
                            font-size: inherit
                            font-family: "BMWTypeNextLatinTT-Thin", serif
                    .arrow_goto
                        width: 10px
                        height: 23px
                        margin-left: 5px
                        background-size: 21px 23px
                        background-position: center 2px

@media screen and (max-width: 650px)
    #exterior
        .bg_c3
            // background-size: 100% auto
            // background-position: center calc(50% - 20px)
            // background-position: center calc(50% - 12vw + 100px)
            .f2_img
                // background-size: auto 100%
            .contain-img
                display: block
            .main-cover
                // top: calc(2.6vw + 300px + 52.7% - 367px)
                top: 68%
                .title_sub
                    margin: 0
                    .pc_break
                        display: none
                    .mobile_break
                        display: block
            .cover
                height: 55%
                background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9) 76%)
@media screen and (max-width: 420px)
    #exterior
        .bg_c3
            // background-size: 100% auto
            // background-position: center calc(50% - 20px)
            // background-position: center calc(50% - 12vw + 100px)
            .f2_img
                background-size: auto 100%
    #exterior-text
        .sticky-wrapper
            .features_B
                .feature
                    &.feature_B-1
                        left: calc(18.5vw + 205.8px + 34.4vh - 333px)
                        top: calc(7.5vw + 590px + 48.7% - 414px)
                    &.feature_B-2
                        left: calc(13vw + 19.5px + 8.4vh - 90px)
                        top: calc(-2.5vw + 296.7px + 48.7% - 414px)
@media screen and (max-height: 600px)
    #exterior
        .bg_c3
            .main-cover
                top: 63%
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    &.feature_A-1
                        transform: translateY(40px)
                        &::before
                            height: 230px
                        &.rush-in
                            transform: translate(0px, 60px)
                    &.feature_A-2
                        &.rush-in
                            transform: translate(0px, 40px)
                    &.feature_B-1
                        &::before
                            height: 90px
                            top: -100px
                    &.feature_B-2
                        &::before
                            height: 90px
</style>
